import env from '@config/env';

export const getAssetIcon = (asset: string) => {
  return `${env.API_URL}/coins/logo/${asset.toLowerCase()}`;
};
